import { AppBrandLogo } from "@/components/layouts/app-brand-logo";
import { useTheme } from "@/components/providers/use-theme";
import { Button, cn, useSidebar } from "@cmde/shadcn";
import { useIsMobile } from "@cmde/hooks";
import { MenuIcon } from "lucide-react";

export const AppHeaderLogo = () => {
  const { theme } = useTheme();
  const isMobile = useIsMobile();
  const { toggleSidebar } = useSidebar();

  return (
    <div className="flex items-center gap-2">
      <Button variant="ghost" size="icon" className={cn(!isMobile && "hidden")} onClick={toggleSidebar}>
        <MenuIcon className="dark:text-secondary size-5" />
      </Button>
      <AppBrandLogo theme={theme} className="[&_img]:h-5!" />
    </div>
  );
};
